<div class="row" style="padding-top: 5%">
  <div class="col-4"></div>
  <div class="col-4"><h1 style="color: #E0FFFF;">Partecipa alla tua Lezione Privata</h1></div>
  <div class="col-4"></div>

  <div class="col-6"><div class="thumbnail"><img style="width: 40%" class="rounded float-right" src="/assets/p2.jpg"></div></div>
  <div class="col-6"><div class="thumbnail"><img style="width: 50%" class="rounded float-left" src="/assets/p3.png" ></div></div>
  <div class="col-4"></div>
  <div class="col-4"><p style="color: #E0FFFF;">Assicurati prima di aver scaricato l'app Google Meet se stai utilizzando il cellulare.</p></div>
  <div class="col-4"></div>

  <div class="col-5"><button type="button" (click)="logout()" class="btn btn-secondary btn-lg">Logout</button></div>
  <div class="col-4" *ngFor="let c of linki"><a href="{{c.payload.doc.data().link}}">

    <button type="button" class="btn btn-secondary btn-lg">Partecipa</button></a>

  </div>
    <div class="col-4"></div>

</div>

